module.exports = __webpack_public_path__ + "static/media/meaningful-review-product1-small.747d9964.svg";